/**
 * Touchpoint names — the identifiers a host mounts this module's views by.
 *
 * They live in `shared` because both sides need them and neither owns the other:
 * the client declares them in its micro-frontend manifest, and the demo-app host
 * mounts by them. A host outside this repo (app-base) reads them from the manifest.
 *
 * **Every name carries the `trexpert-` prefix on purpose.** A host composes several
 * modules into one application and resolves a touchpoint by its bare name across all
 * of them, so an unprefixed `dashboard`, `inbox` or `settings` would collide with any
 * second portal module. The names are identical to the custom-element tags for the
 * same reason a URL and its route are: one thing, named once.
 */
export const TOUCHPOINTS = {
    dashboard: "trexpert-dashboard",
    mandateList: "trexpert-mandate-list",
    mandateWorkspace: "trexpert-mandate-workspace",
    uploadDocument: "trexpert-upload-document",
    inbox: "trexpert-inbox",
    settings: "trexpert-settings",
    taskListEditor: "trexpert-task-list-editor",
    taskPlans: "trexpert-task-plans",
    taskListDetail: "trexpert-task-list-detail",
    taskListView: "trexpert-task-list-view",
    taskOverview: "trexpert-task-overview",
    documentOverview: "trexpert-document-overview",
    forms: "trexpert-forms",
} as const;

export type TouchpointName = (typeof TOUCHPOINTS)[keyof typeof TOUCHPOINTS];
